// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__dziXl"};